// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__sB2l0","content":"styles_content__1zAhi","checkbox":"styles_checkbox__2hB48","checkboxLabel":"styles_checkboxLabel__1p9to"};